import styled from 'styled-components';
import { layout, flexbox, space } from 'styled-system'


export const Container = styled.div`
  padding: ${(props) => props.theme.spacing(0, 6)};
  ${layout}
  ${flexbox}
  ${space}
`;